import type { OrgPlanningReviewScope } from './orgPlanningReviewKey';
import { subscribeProtectedPlanningInvalidation } from './protectedPlanningGeneration';

/** Value-free equivalences acknowledged by this command history, never guessed from a head list. */
const histories = new Map<string, { folderId: string; aliases: Map<string, string> }>();
function aliases(scope: OrgPlanningReviewScope, epoch: number) {
  const key = JSON.stringify([scope.folderId, scope.diagramId, scope.principalId, scope.actorOrgId,
    scope.sessionGeneration, scope.folderGeneration, epoch]);
  let history = histories.get(key);
  if (!history) { history = { folderId: scope.folderId, aliases: new Map() }; histories.set(key, history); }
  return history.aliases;
}
export function draftHistoryEquivalent(scope: OrgPlanningReviewScope, epoch: number, head: string | undefined): string | undefined {
  return head ? aliases(scope, epoch).get(head) ?? head : undefined;
}
export function acknowledgeDraftHistoryRestore(scope: OrgPlanningReviewScope, epoch: number, head: string, restoredFrom: string): void {
  aliases(scope, epoch).set(head, draftHistoryEquivalent(scope, epoch, restoredFrom)!);
}
subscribeProtectedPlanningInvalidation((folderId) => {
  for (const [key, history] of histories) if (!folderId || history.folderId === folderId) histories.delete(key);
});
